export function initReportData(state, payload) {
  return {
    editable: !!(payload && payload.editable),
    isProcessing: !!(payload && payload.editable),
    dirty: false,
    saving: false,
    error: null,
  };
}
